<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="3" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container from '@/components/Container.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      Container:{
        subtitle:'RapidPlan PT',
        videosrc:'P04.mp4',
        title:'基於人工智能之質子治療計畫系統',
        list:[
          {
            body:"瓦里安全新進入智慧放射治療世代，有別於傳統治療計畫系統;瓦里安全新導入人工智能Machine Learning技術於質子治療計畫系統RapidPlan PT, 使得精準醫學邁進智慧化新世代。RapidPlan PT 是基於臨床需求，創建臨床單位放射治療計畫知識庫，同時導入機器學習技術，使得質子治療放射處方搭配智慧化系統以最佳化處方施予患者。"

          }

        ]
      }

    }
  },
  components: {
    Back,Container,Bigmenu
  },
  methods:{
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
